import { SpotStatus, type RoomLayoutSpot } from './RoomLayoutMap.types';
import { applySpotsOverlayForMap } from './applySpotsOverlayForMap';

export type BookableAvailability = {
  bookableCount: number;
  hasBookableSpots: boolean;
};

export function countBookableSpots(spots: RoomLayoutSpot[]): BookableAvailability {
  const bookableCount = spots.filter((spot) => spot.status === SpotStatus.BOOKABLE).length;
  return {
    bookableCount,
    hasBookableSpots: bookableCount > 0
  };
}

/** Same overlay + bookable count as {@link RoomLayoutMap} `spotsToShow` / `onBookableAvailabilityChange`. */
export function computeBookableSpotsForMap(
  layoutSpots: RoomLayoutSpot[],
  reservedSpotKeys?: string[],
  assignedSpotKey?: string | null
): BookableAvailability {
  return countBookableSpots(
    applySpotsOverlayForMap(layoutSpots, reservedSpotKeys, assignedSpotKey)
  );
}
